import { Button, FormControl, FormLabel, Input, VStack, Box, Heading, useToast } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStateContext } from '../../../../context/ContextProvider';
import axiosClient from '../../../../axios-client';

function WooCommerce() {
    const { user } = useStateContext();
    const { t } = useTranslation();
    const toast = useToast();

    const [consumer_key, setConsumer_key] = useState('');
    const [consumer_secret, setConsumer_secret] = useState('');
    const [store_url, setStore_url] = useState('');
    const [loading, setLoading] = useState(false);

    const addNewAccountWooCommerce = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('client', user?.id);
            formData.append('consumer_key', consumer_key);
            formData.append('consumer_secret', consumer_secret);
            formData.append('store_url', store_url);

            await axiosClient.post('/wooCommerceAccount/', formData);
            toast({ title: t('Succès'), description: t('Compte ajouté avec succès !'), status: 'success', duration: 3000, isClosable: true });
            setConsumer_key('');
            setConsumer_secret('');
            setStore_url('');
        } catch (error) {
            toast({
                title: t('Erreur'),
                description: t("Échec de l'ajout du compte."),
                status: 'error',
                duration: 3000,
                isClosable: true
            });
            // // console.error('ERROR Post:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box maxW={{ base: '90%', md: '500px' }} mt={5} mx="auto" p={6} boxShadow="lg" borderRadius="lg" bg="white">
            <Heading as="h2" size="lg" textAlign="center" mb={6}>
                {t('Connexion WooCommerce')}
            </Heading>
            <VStack spacing={4}>
                <FormControl id="consumer_key" isRequired>
                    <FormLabel>{t('Clé du consommateur')}</FormLabel>
                    <Input
                        type="text"
                        placeholder={t('Clé du consommateur')}
                        value={consumer_key}
                        onChange={(e) => setConsumer_key(e.target.value)}
                        _focus={{ boxShadow: 'none', borderColor: 'blue.500' }}
                    />
                </FormControl>
                <FormControl id="consumer_secret" isRequired>
                    <FormLabel>{t('Secret du consommateur')}</FormLabel>
                    <Input
                        type="text"
                        placeholder={t('Secret du consommateur')}
                        value={consumer_secret}
                        onChange={(e) => setConsumer_secret(e.target.value)}
                        _focus={{ boxShadow: 'none', borderColor: 'blue.500' }}
                    />
                </FormControl>
                <FormControl id="store_url" isRequired>
                    <FormLabel>{t('Lien du magasin')}</FormLabel>
                    <Input
                        type="text"
                        placeholder={t('Lien du magasin')}
                        value={store_url}
                        onChange={(e) => setStore_url(e.target.value)}
                        _focus={{ boxShadow: 'none', borderColor: 'blue.500' }}
                    />
                </FormControl>
                <Button
                    colorScheme="blue"
                    width="full"
                    onClick={addNewAccountWooCommerce}
                    isLoading={loading}
                >
                    {t('Ajouter')}
                </Button>
            </VStack>
        </Box>
    );
}

export default WooCommerce;
